export enum FeeScope {
    PERSON = "person",
    EQUIPMENT = "equipment",
    OUTING = "outing",
    ADDON = "addon",
    MERCHANDISE = "merchandise",
}

export enum FeeScopeModifier {
    PER_DAY = "day",
    EXCLUDE_ADDON = "excludeAddon",
    EQUIPMENT_ONLY = "equipment_subtotal",
    ADDON_ONLY = "merchandise_subtotal",
    PICKUP_ONLY = "pickup_only",
    WARE_ONLY = "ware_only",
    ALL = "all",
}
